import TickerTapeInsertModal, { TICKER_TAPE_INSERT_MODAL } from './modal';

export { TICKER_TAPE_INSERT_MODAL };

export default TickerTapeInsertModal;
